import { render, staticRenderFns } from "./openBalanceWarn.vue?vue&type=template&id=5e236738"
import script from "./openBalanceWarn.vue?vue&type=script&lang=js"
export * from "./openBalanceWarn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports